import { Component } from 'react';

export default class MenuList extends Component {
	constructor(props,context) {
		super(props,context);
	}

	componentDidMount() {
		this.props.actions.fetchMenuList();
	}

	render() {
		return null;
	}
}


// WEBPACK FOOTER //
// ./src/components/PageNav/MenuList.js